import { BaseEntity } from '../../xform-compat';


export class Permission implements BaseEntity {
  id: number;
  code?: string;
  name?: string;
  active?: boolean;

  constructor(permission: any) {
    this.id = permission.id;
    this.code = permission.code;
    this.active = permission.active;
    this.name = permission.name;
  }
}

